import Button from '@doordash/component-button'
import { PhoneField } from '@doordash/component-fields'
import { Text, Inset, StackChildren } from '@doordash/design-language'
import * as React from 'react'

import s from './strings'

type Props = {
  phone: string
  onPhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSubmit: () => Promise<void>
}

export const TalkToSpecialistForm: React.SFC<Props> = ({
  phone,
  onPhoneChange,
  onSubmit,
}) => (
  <Inset isSquished={true} size={Inset.Sizes.Small}>
    <StackChildren size={StackChildren.Sizes.XSmall}>
      <Text
        display={Text.DisplayModes.Flex}
        textAlign={Text.TextAlignments.left}
        styles={Text.Styles.Bold24}
      >
        {s.title()}
      </Text>
      <Text
        display={Text.DisplayModes.Flex}
        textAlign={Text.TextAlignments.left}
        styles={Text.Styles.Medium14}
      >
        {s.subTitle()}
      </Text>
      <PhoneField
        label={s.phoneInputLabel()}
        onChange={onPhoneChange}
        value={phone}
      />
      <Button
        type={Button.Types.PrimaryPill}
        size={Button.Sizes.Large}
        onClick={onSubmit}
      >
        {s.button()}
      </Button>
    </StackChildren>
  </Inset>
)

export default TalkToSpecialistForm
